import { ICart, ICartAddon, ICartOffer } from "@features/cart/ICart";
import { EDataLayerEventType, sendEvent } from "./dataLayer";
import { getCartConfig, IDataLayerEcommerceItem, mapAddonListToItem, mapItems, mapOfferToItem } from "./cart";

export interface IDataLayerRemoveCartEvent {
    event: EDataLayerEventType.REMOVE_CART;
    ecommerce: {
        items: IDataLayerEcommerceItem[];
    };
    cartConfig: string;
}

export const sendRemoveCartEvent = (cart: ICart, offer: ICartOffer) => {
    sendEvent({
        event: EDataLayerEventType.REMOVE_CART,
        ecommerce: {
            items: [mapOfferToItem(offer)],
        },
        cartConfig: getCartConfig(mapItems(cart.offers)),
    });
};

export const sendRemoveAddonEvent = (cart: ICart, addonList: ICartAddon[]) => {
    sendEvent({
        event: EDataLayerEventType.REMOVE_CART,
        ecommerce: {
            items: [mapAddonListToItem(addonList)],
        },
        cartConfig: getCartConfig(mapItems(cart.offers)),
    });
};

export const sendClearCartEvent = (cart: ICart) => {
    sendEvent({
        event: EDataLayerEventType.REMOVE_CART,
        ecommerce: {
            items: mapItems(cart.offers),
        },
        cartConfig: "",
    });
};
